//GLOBAL - components from npm
import React from "react";
import "./stackedBarChartSearch.css";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

//ASSETS - icons, images...
import { ReactComponent as EmptyState } from "../../../../build/images/emptystatemanagerhorizontal.svg";

// SERVICES

const initialData = [
  {
    name: "JAN",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
  {
    name: "FEV",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
  {
    name: "MAR",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
  {
    name: "ABR",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
  {
    name: "MAI",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
  {
    name: "JUN",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
  {
    name: "JUL",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
  {
    name: "AGO",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
  {
    name: "SET",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
  {
    name: "OUT",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
  {
    name: "NOV",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
  {
    name: "DEZ",
    currentYearSended: 50000,
    currentYearAnswered: 50000,
    lastYearSended: 25000,
    lastYearAnswered: 25000,
  },
];

function StackedBarChartSearch({
  dataStart = initialData,
  currentYear = "2024",
  lastYear = "2023",
}) {
  //FUNCTIONS
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{`${label}`}</p>
          {payload.map((data) => {
            if (
              data.name === `Enviadas - ${currentYear}` ||
              data.name === `Enviadas - ${lastYear}`
            ) {
              if (data.name === `Enviadas - ${currentYear}`) {
                const totalSended =
                  data.value + data.payload.currentYearAnswered;
                return (
                  <p style={{ color: `${data.fill}`, order: 0 }}>{`${
                    data.name
                  } : ${totalSended.toLocaleString("pt-BR")}`}</p>
                );
              } else {
                const totalSended = data.value + data.payload.lastYearAnswered;
                return (
                  <p style={{ color: `${data.fill}`, order: 2 }}>{`${
                    data.name
                  } : ${totalSended.toLocaleString("pt-BR")}`}</p>
                );
              }
            } else {
              if (data.name === `Respondidas - ${currentYear}`) {
                return (
                  <p style={{ color: `${data.fill}`, order: 1 }}>{`${
                    data.name
                  } : ${data.value.toLocaleString("pt-BR")}`}</p>
                );
              } else {
                return (
                  <p style={{ color: `${data.fill}`, order: 3 }}>{`${
                    data.name
                  } : ${data.value.toLocaleString("pt-BR")}`}</p>
                );
              }
            }
          })}
        </div>
      );
    }

    return null;
  };

  const CustomXAxisTick = ({ x, y, payload }) => {
    return (
      <text
        x={x}
        y={y}
        dy={8}
        fill="rgba(0, 0, 0, 0.38)"
        textAnchor="middle"
        fontSize={12}
        fontFamily="Inter"
      >
        {payload.value}
      </text>
    );
  };

  const CustomYAxisTick = ({ x, y, payload }) => {
    return (
      <g transform={`translate(${18},${y + 4})`}>
        <text
          x={0}
          y={0}
          textAnchor="start"
          fill="rgba(0, 0, 0, 0.38)"
          style={{ fontFamily: "Inter", fontSize: 12 }}
        >
          {payload.value.toLocaleString("pt-BR")}
        </text>
      </g>
    );
  };

  const CustomizedLabel = (props) => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            gap: 8,
            justifyContent: "center",
            alignItems: "center",
            marginLeft: 45,
            paddingTop: 6,
          }}
        >
          {props && props.payload
            ? props.payload.map((item) => {
                switch (item.value) {
                  case `Enviadas - ${currentYear}`:
                    return (
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          order: 0,
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <circle cx="6" cy="6" r="6" fill="#455CC7" />
                        </svg>
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "112.5%",
                            letterSpacing: 0.25,
                            color: "#757575",
                          }}
                        >
                          {item.value}
                        </div>
                      </div>
                    );
                  case `Respondidas - ${currentYear}`:
                    return (
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          order: 1,
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <circle cx="6" cy="6" r="6" fill="#1E88E5" />
                        </svg>
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "112.5%",
                            letterSpacing: 0.25,
                            color: "#757575",
                          }}
                        >
                          {item.value}
                        </div>
                      </div>
                    );
                  case `Enviadas - ${lastYear}`:
                    return (
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          order: 2,
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <circle cx="6" cy="6" r="6" fill="#43A047" />
                        </svg>
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "112.5%",
                            letterSpacing: 0.25,
                            color: "#757575",
                          }}
                        >
                          {`Enviadas - ${lastYear}`}
                        </div>
                      </div>
                    );
                  case `Respondidas - ${lastYear}`:
                    return (
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          order: 3,
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <circle cx="6" cy="6" r="6" fill="#C0CA33" />
                        </svg>
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "112.5%",
                            letterSpacing: 0.25,
                            color: "#757575",
                          }}
                        >
                          {`Respondidas - ${lastYear}`}
                        </div>
                      </div>
                    );
                  default:
                    return null;
                }
              })
            : null}
        </div>
      </div>
    );
  };

  // USE EFFECTS
  /*
  useEffect(() => {
    getDataByHour(startDay, endDay, 54, 3002, 30, 30, true, null, null);
  }, []);
  */

  return (
    <div className="stackedBarChartSearchComparisons">
      {dataStart && dataStart.length ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
              // width={500}
              // height={300}
              data={dataStart}
              margin={{
                top: 20,
                right: 30,
                left: 0,
                bottom: 5,
              }}
            >
              <CartesianGrid
                vertical={false}
                strokeDasharray="none"
                strokeWidth="1"
                stroke="rgba(0, 0, 0, 0.05)"
              />
              <XAxis dataKey="name" tick={<CustomXAxisTick />} />
              <YAxis
                axisLine={false}
                tick={<CustomYAxisTick />}
                // tickFormatter={(value) => {
                //   const isValidValue = value.toString().split(".").length <= 1;
                //   if (isValidValue) {
                //     return value;
                //   } else {
                //     return "";
                //   }
                // }}
              />
              <Tooltip content={<CustomTooltip />} />
              <Legend
                layout="horizontal"
                verticalAlign="bottom"
                align="center"
                fontSize={12}
                content={CustomizedLabel}
              />
              <Bar
                dataKey="currentYearAnswered"
                stackId="currentYear"
                name={`Respondidas - ${currentYear}`}
                fill="#1E88E5"
                barSize={8}
              />
              <Bar
                dataKey="currentYearSended"
                stackId="currentYear"
                name={`Enviadas - ${currentYear}`}
                fill="#455CC7"
                barSize={8}
                radius={[4, 4, 0, 0]}
              />
              <Bar
                dataKey="lastYearAnswered"
                stackId="lastYear"
                name={`Respondidas - ${lastYear}`}
                fill="#C0CA33"
                barSize={8}
              />
              <Bar
                dataKey="lastYearSended"
                stackId="lastYear"
                name={`Enviadas - ${lastYear}`}
                fill="#43A047"
                barSize={8}
                radius={[4, 4, 0, 0]}
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="card-table__area-empty">
          <EmptyState />
        </div>
      )}
    </div>
  );
}

export default StackedBarChartSearch;
